import React from "react";
import { Button, Popover, Row, Space } from "antd";
import { MdSecurity } from "react-icons/md";
import Can from "../../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
export default function Download({ greyBoxData }) {
  const content = () => {
    return (
      <div style={{ borderRadius: 4 }}>
        {greyBoxData.map((item) => {
          return (
            <>
              <Row>
                <Space direction="horizontal">{item.render()}</Space>
                <span style={{ color: "#686E6D", marginLeft: "0.5rem" }}>
                  {item.message}
                </span>
              </Row>
            </>
          );
        })}
      </div>
    );
  };
  return (
    <Can
      I={PERMISSIONS.update_catalogues_link_security.slug}
      a={PERMISSIONS.update_catalogues_link_security.permissionType}
    >
      {(allowed) => (
        <Popover placement="bottom" content={content} trigger="hover">
          <Button
            size="large"
            type="default"
            className="table-control"
            icon={<MdSecurity size={25} />}
          ></Button>
        </Popover>
      )}
    </Can>
  );
}
